import React, { useEffect } from "react";
import { useDispatch } from "react-redux";
import useMulticotizadorSelector from "./useMulticotizadorSelector";
import {
  clearContratarCurrentPoliza,
  setContratarCurrentPoliza,
} from "../actions";
import PolizaDetail from "~business/polizaDetail/PolizaDetail";
import MulticotizadorContent from "./MulticotizadorContent";

const useReduxSelector = () =>
  useMulticotizadorSelector((state) => {
    return {
      currentPoliza: state.currentPoliza.value,
    };
  });

const DetallePolizaStep = () => {
  const dispatch = useDispatch();
  const { currentPoliza } = useReduxSelector();

  useEffect(() => {
    dispatch(clearContratarCurrentPoliza());
  }, [dispatch]);

  const handleContratar = () => {
    dispatch(
      setContratarCurrentPoliza({
        value: currentPoliza,
        open: true,
        contratada: true,
      })
    );
  };

  if (currentPoliza)
    return (
      <MulticotizadorContent>
        <PolizaDetail poliza={currentPoliza} onContratar={handleContratar} />
      </MulticotizadorContent>
    );

  return null;
};

export default DetallePolizaStep;
